export default "__VITE_ASSET__6cf6c8ff__"